import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { Grid } from "./GridBlock";
import { defaultData } from "./GridBlockDefaultData";
import { meta } from "./GridBlockMetaData";

export const GridBlock: BlockExport = {
  type: "component",
  Block: Grid,
  imagePreview: {
    type: "icon",
    name: "24-builder-element-grid",
    size: 24,
  },
  defaultData,
  meta,
};
